import axios from "axios";
import { Base_URL } from "../url";

export const saveEventDetails = async (eventData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/EventDetails/SaveEvents`,
      eventData,
      {
        headers: {
          "Content-Type": "application/json",
        },
      },
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save event";
  }
};

export const updateEvent = async (eventCode, data) => {
  const res = await axios.put(
    `${Base_URL}/EventDetails/UpdateEvent/${eventCode}`,
    data,
  );
  return res.data;
};

export const addParticipants = async (eventCode, data) => {
  const res = await axios.post(
    `${Base_URL}/EventDetails/AddParticipants/${eventCode}`,
    data,
  );
  return res.data;
};

export const addReminder = async (eventCode, data) => {
  const res = await axios.post(
    `${Base_URL}/EventDetails/AddReminder/${eventCode}`,
    data,
  );
  return res.data;
};

export const addMoM = async (eventCode, data) => {
  const res = await axios.post(
    `${Base_URL}/EventDetails/AddMoM/${eventCode}`,
    data,
  );
  return res.data;
};

export const getAllEventTypes = async () => {
  try {
    const res = await axios.get(`${Base_URL}/EventDetails/GetAllEventTypes`);
    return res.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch event types";
  }
};

export const getEventTypeByGuid = async (guid) => {
  try {
    const res = await axios.get(
      `${Base_URL}/EventDetails/GetEventTypeByGuid/${guid}`,
    );
    return res.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch event type";
  }
};
